/*
 * Palo Alto Theme
 *
 * Use this file to add custom Javascript to Palo Alto.  Keeping your custom
 * Javascript in this fill will make it easier to update Palo Alto. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line

  // console.log('window.theme.grouped_products', window.theme.grouped_products)
  //trigger First color swatch selected when product has color grouping and actual color variant is hidden on PDP
  if (window.theme.grouped_products) {
    if (
      document.querySelectorAll(`[data-swatches-button] input[type="radio"]`)
    ) {
      document
        .querySelectorAll(`[data-swatches-button] input[type="radio"]`)[0]
        .click();
    }
  }

  //append icon block to Product descrioption tab on page load
  document.addEventListener("DOMContentLoaded", function () {
    // Check if body has the class "template-product"
    if (document.body.classList.contains("template-product")) {
      // Get all elements with class ".block-icon"
      const iconBlocks = document.querySelectorAll(".block-icon");

      // Check if any ".block-icon" elements exist
      if (iconBlocks.length > 0) {
        const accordionInner = document.querySelector(
          ".product__accordion__inner"
        );

        // Check if the target element ".product__accordion__inner" exists
        if (accordionInner) {
          iconBlocks.forEach((block) => {
            // Clone the block
            // const clonedBlock = block.cloneNode(true);
            // Append cloned block to ".product__accordion__inner"
            // accordionInner.appendChild(clonedBlock);
            // Remove the original block from its original position
            // block.remove();
          });
        }
      }
    }

    /* PLP color swatch click handler*/
    document.body.addEventListener("click", function (e) {
      // console.log('e.target', e.target)
      //PLP swatch click event
      if (e.target.classList.contains("swatch__lsink")) {
        var colorInput = e.target.nextElementSibling(".swatch__label");
        var parentInput = e.target.closest(".variant-input-wrap");
        var siblings = parentInput.parentNode.children;
        // Uncheck other inputs
        Array.from(siblings).forEach(function (sibling) {
          if (sibling !== parentInput) {
            // console.log('sibling.querySelector("input")',sibling.querySelector("input"))
            if (sibling.querySelector("input"))
              sibling.querySelector("input").removeAttribute("checked");
          }
        });

        // colorInput.setAttribute("checked", "checked");

        var image_1 = colorInput.dataset.image1,
          image_2 = colorInput.dataset.image2,
          title = colorInput.dataset.title,
          price = colorInput.dataset.price,
          sale_price = colorInput.dataset.sale,
          saving = colorInput.dataset.saving,
          url = colorInput.dataset.url,
          first_image = e.target
            .closest(".product-grid-item")
            .querySelector(
              "figure.product__media:not(.product__media__hover-img) img"
            ),
          second_image = e.target
            .closest(".product-grid-item")
            .querySelector("figure.product__media__hover-img img"),
          main_url = e.target
            .closest(".product-grid-item")
            .querySelector(".product__media__holder"),
          main_price = e.target
            .closest(".product-grid-item")
            .querySelector(".product-grid-item__price"),
          main_title = e.target
            .closest(".product-grid-item")
            .querySelector(".product-grid-item__title"),
          colorselected = e.target
            .closest(".product-grid-item")
            .querySelector("[data-variant-color-label]");
        // colorselected.textContent = colorInput.value;
        // console.log('image_1', image_1)
        // console.log('title', title)
        // console.log('price', price)
        // console.log('first_image', first_image)
        // console.log('second_image', second_image)
        // console.log('main_url', main_url)

        var sale_structure = `<a class="product-grid-item__price price" href="${url}" data-grid-link="">
<span class="product-grid-item__price-new">${sale_price}</span><s>${price}</s></a>`;

        // if (saving) {
        //   sale_structure += `<span class="grid-product__price--savings">Save ${saving}</span></div>`;
        // }

        main_url.setAttribute("href", url);
        main_price.textContent = price;
        main_title.textContent = title;

        if (sale_price && sale_price > price) {
          main_price.innerHTML = sale_structure;
        } else {
          main_price.innerHTML = `<a class="product-grid-item__price price" href="${url}" data-grid-link="">${price}</a>`;
        }

        if (image_1 !== "") {
          first_image.setAttribute("srcset", image_1);
          second_image.setAttribute("srcset", image_2);
        }
      }
    });
  });

  document.addEventListener("DOMContentLoaded", function () {
    const navLinks = document.querySelectorAll(".pdp-features-nav-link");
    const images = document.querySelectorAll(".pdp-features-image");

    // Function to show/hide images based on the clicked tab
    function updateTabContent(event) {
      // Get the aria-controls attribute of the clicked tab
      const targetId = event.target.getAttribute("aria-controls");

      // Hide all images
      images.forEach((image) => {
        image.style.display = "none";
      });

      // Remove active class from all tabs
      navLinks.forEach((link) => {
        link.classList.remove("pdp-features-nav-link--active");
        link.setAttribute("aria-selected", "false");
      });

      // Show the target image
      const targetImage = document.getElementById(targetId);
      if (targetImage) {
        targetImage.style.display = "block";
      }

      // Add active class to the clicked tab
      event.target.classList.add("pdp-features-nav-link--active");
      event.target.setAttribute("aria-selected", "true");
    }

    // Attach click event listeners to each tab
    navLinks.forEach((link) => {
      link.addEventListener("click", updateTabContent);
    });

    // var cntrData = {};
    // try {
    //   if (document.querySelectorAll(`.product__form button[type="submit"], [data-add-to-cart]`)) {
    //     document
    //       document.querySelectorAll(`.product__form button[type="submit"], [data-add-to-cart]`).forEach((ele)=>{
    //         // console.log(ele)
    //         ele.addEventListener("click", function () {
    //           cntrData = { "addtocart-Vooray": "button" };
    //           if (cntrUpTag) {
    //             console.log(cntrData, cntrUpTag);
    //             cntrUpTag.track("cntrData", "127835058577fb6a");
    //           }
    //         });
    //       })
          
    //   }

    //   if (document.querySelector(`button.cart__checkout`)) {
    //     document
    //       .querySelector(`button.cart__checkout`)
    //       .addEventListener("click", function () {
    //         cntrData = { checkout: "button" };
    //         if (cntrUpTag) {
    //           cntrUpTag.track("cntrData", "127835058577fb6a");
    //           console.log(cntrData, cntrUpTag);
    //         }
    //       });
    //   }
    // } catch (error) {
    //   console.log("cntrtag error", error);
    // }


    // var imgSelect = `.product-single__media img`;
    // if (document.querySelectorAll(imgSelect)) {
    //   if(window.innerWidth > 768){
    //     // $(`.product-single__media figure`).zoom();
    //     $(`.product-single__media figure`).each(function(ele){
    //       var Zoomimg = $(this).find('img').attr('data-zoom-image');
    //       // console.log(Zoomimg)
    //       $(this).zoom({url: Zoomimg});
    //     })
    //     // $(`.product-single__media figure`).zoom({url: this.getAttribute('data-zoom-image')});
    //   }
    // }

    
  });
  /* 07-02-2025 Zoom feature on PDP */
function enableZoom(zoomType) {
  if ($(window).width() > 768) {
    document.querySelectorAll(".product-single__media--image").forEach((item) => {
      const img = item.querySelector(".zoomable");
      if(img == null)return
      const zoomedImage = item.querySelector(".zoomed-image");
      const zoomUrl = img.getAttribute("data-zoom");

      // Ensure background image is set immediately
      zoomedImage.style.backgroundImage = `url(${zoomUrl})`;

      function updateZoomPosition(event) {
        const rect = item.getBoundingClientRect();
        const x = ((event.clientX - rect.left) / rect.width) * 100;
        const y = ((event.clientY - rect.top) / rect.height) * 100;
        zoomedImage.style.backgroundPosition = `${x}% ${y}%`;
      }

      if (zoomType === "hover") {
        item.addEventListener("mouseenter", function (event) {
          zoomedImage.style.display = "block";
          zoomedImage.style.opacity = "1";
          updateZoomPosition(event);
        });

        item.addEventListener("mousemove", function (event) {
          item.classList.remove("zoom-active");
          updateZoomPosition(event);
        });

        item.addEventListener("mouseleave", function () {
          zoomedImage.style.opacity = "0";
          setTimeout(() => {
            zoomedImage.style.display = "none";
          }, 300);
        });
      } else if (zoomType === "click") {
        let isZoomed = false;

        item.addEventListener("click", function (event) {
          item.classList.add("zoom-active");
          const rect = item.getBoundingClientRect();
          const x = ((event.clientX - rect.left) / rect.width) * 100;
          const y = ((event.clientY - rect.top) / rect.height) * 100;

          if (!isZoomed) {
            zoomedImage.style.display = "block";
            zoomedImage.style.opacity = "1";
            zoomedImage.style.backgroundPosition = `${x}% ${y}%`;
            isZoomed = true;
          } else {
            item.classList.remove("zoom-active");
            zoomedImage.style.opacity = "0";
            setTimeout(() => {
              zoomedImage.style.display = "none";
            }, 300);
            isZoomed = false;
          }
        });

        item.addEventListener("mousemove", function (event) {
          if (isZoomed) {
            updateZoomPosition(event);
          }
        });

        item.addEventListener("mouseleave", function () {
          if (isZoomed) {
            item.classList.remove("zoom-active");
            zoomedImage.style.opacity = "0";
            setTimeout(() => {
              zoomedImage.style.display = "none";
            }, 300);
            isZoomed = false;
          }
        });
      }
    });
  }
}

function preloadZoomImages() {
  document.querySelectorAll(".zoomable").forEach((img) => {
    const zoomUrl = img.getAttribute("data-zoom");
    if (zoomUrl) {
      const preloadImg = new Image();
      preloadImg.src = zoomUrl;
    }
  });
}

// Preload zoom images when the page loads
window.addEventListener("load", preloadZoomImages);

$(document).ready(function () {
   enableZoom("click");
   SwiperSlider()
  // if (!$("#main-image-slider-source").hasClass("stackImage-false")) {
  //   enableZoom("hover");
  // } else {
  //   enableZoom("click");
  // }
  
});
function SwiperSlider(){
  const galleryContainer = document.querySelector(".gallery-main");
  var scroller = document.querySelector('.swiper-scrollbar');
  if (!galleryContainer) return;
    galleryMain =  new Swiper(galleryContainer, {
      watchOverflow: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      loop:false,
      preventInteractionOnTransition: true,
      scrollbar: {
        el: scroller,
        draggable: true,
      },
      effect: 'slide'
    });
}

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
